import React from "react";
// import {Link} from "react-router-dom";
// JavaScript plugin that hides or shows a component based on your scroll
import Headroom from "headroom.js";
import './Header.scss';

import {
    Button,
    Col,
    Container,
    Nav,
    Navbar,
    NavbarBrand,
    NavItem,
    NavLink,
    Row,
    UncontrolledCollapse,
} from "reactstrap";
import * as constants from '../../const/constants';
import {withRouter} from "react-router";
import * as actionCreator from "../../store/domain/auth/action";
// import * as commonFunc from "../../utils/commonFunc";
import {connect} from "react-redux";
import swal from "sweetalert";
import * as actionClassCreator from "../../store/domain/classes/action";
import Logo from '../../assets/img/logo/logo-dark.png';
import LogoDark from '../../assets/img/logo/logo-dark.png';
import * as commonFunc from "../../utils/commonFunc";
import {lang, language} from "../../const/language";
import Tooltip from "@material-ui/core/Tooltip";

import {AppHeaderDropdown, AppNavbarBrand, AppSidebarToggler} from '@coreui/react';
import {DropdownItem, DropdownMenu, DropdownToggle} from 'reactstrap';
import cornerImage from "../../assets/img/institute/avatar-placeholder.png";

class DemoNavbar extends React.Component {
    state = {
        collapseClasses: "",
        collapseOpen: false
    };
    onExiting = () => {
        this.setState({
            collapseClasses: "collapsing-out"
        });
    };
    onExited = () => {
        this.setState({
            collapseClasses: ""
        });
    };
    setModalHandler = (str) => {
        if (str === "LOGIN") {
            this.props.history.push(`${constants.BASE_ROUTE}${constants.AUTH_LOGIN_ROUTE}`);
            return;
        }
        if (str === "REG") {
            this.props.history.push(`${constants.BASE_ROUTE}${constants.AUTH_REG_ROUTE}`);
            return;
        }
        this.props.history.push(`${constants.BASE_ROUTE}${constants.HOME_INSTITUTE_ROUTE}`);
    };
    logoutHandler = () => {
        swal({
            title: constants.ALERT_TEXT,
            icon: null,
            closeOnClickOutside: false,
            buttons: {
                cancel: language[lang].NoText,
                dangerMode: {text: language[lang].YesText, value: "action", className: "okay-btn"}
            },
        }).then((value) => {
            switch (value) {
                case "action":
                    commonFunc.removeCookiesValues();
                    this.props.history.push(`${constants.BASE_ROUTE}${constants.AUTH_LOGIN_ROUTE}`);
                    // commonFunc.notifyMessage("Logout successfully",1);
                    break;
                default:
                    break;
            }
        });
    };
    routeHandler = (route) => {
        if (route === constants.HOME_INSTITUTE_ROUTE) {
            this.props.selectPagination(null);
        }
        if (route === constants.HOME_MY_CLASS_ROUTE) {
            this.props.selectMyClassPagination(null);
        }
        if (route === constants.HOME_PROFILE_ROUTE) {
        }
        this.props.history.push(`${constants.BASE_ROUTE}${route}`);
    };

    componentDidMount() {
        let headroom = new Headroom(document.getElementById("navbar-main"));
        // initialise
        headroom.init();
    }

    render() {
        let {active, userType, headerTransparent} = this.props;
        return (
            <>
                <header className="header-global ">
                    <Navbar
                        className={`navbar-main navbar-transparent navbar-ligh headroom ${headerTransparent}`}
                        expand="lg"
                        id="navbar-main"
                    >
                        <Container className="about">
                            <NavbarBrand className="mr-lg-5">
                                {/*<img*/}
                                {/*    className={"logo-img"}*/}
                                {/*    alt="..."*/}
                                {/*    src={Logo}*/}
                                {/*/>*/}
                                {/*<p className={"main-txt n-m"}> {"- Teach Me -"}</p>*/}
                            </NavbarBrand>
                            <button className="navbar-toggler" id="navbar_global">
                                <span className="toggle-ctrl"> <i className="icofont-justify-all"/></span>
                            </button>
                            <UncontrolledCollapse
                                toggler="#navbar_global"
                                navbar
                                className={this.state.collapseClasses}
                                onExiting={this.onExiting}
                                onExited={this.onExited}

                            >
                                <div className="navbar-collapse-header mobile">
                                    <Row>
                                        <Col className="collapse-brand" xs="8">
                                            {
                                                userType === 1 &&
                                                <div>
                                                    <div className="font-weight-bold user_name1">
                                                        {this.props.userObj.name}</div>
                                                </div>
                                            }
                                        </Col>
                                        <Col className="collapse-close" xs="4">
                                            <button className="navbar-toggler" id="navbar_global">
                                                <span/>
                                                <span/>
                                            </button>
                                        </Col>
                                    </Row>
                                </div>
                                <Nav className="navbar-nav-hover align-items-lg-center  " navbar>
                                    {/*mobile - d-lg-none*/}
                                    {
                                        userType === 1 ?
                                            <NavItem className="d-lg-none ml-lg-4 mb-1 mb-4 mr- ">

                                                <Tooltip title='Home Page'>
                                                    <Button
                                                        onClick={() => this.routeHandler(constants.HOME_INSTITUTE_ROUTE)}
                                                        className={`btn-neutral mb-1 ${active === 0 ? `nav-link-active` : ``}`}
                                                        color="default">
                                                        <span
                                                            className="nav-link-inner--text">{language[lang].HomePage}</span>
                                                    </Button>
                                                </Tooltip>

                                                <Tooltip title='Enrolled Classes'>
                                                    <Button
                                                        onClick={() => this.routeHandler(constants.HOME_MY_CLASS_ROUTE)}
                                                        className={`btn-neutral mb-1 ${active === 1 ? `nav-link-active` : ``}`}
                                                        color="default">
                                                        <span
                                                            className="nav-link-inner--text">{language[lang].MyClass}</span>
                                                    </Button>
                                                </Tooltip>

                                                <Tooltip title='Enrolled Lessons'>
                                                    <Button
                                                        onClick={() => this.routeHandler(constants.HOME_MY_LESSONS_ROUTE)}
                                                        className={`btn-neutral mb-1 ${active === 2 ? `nav-link-active` : ``}`}
                                                        color="default">
                                                        <span
                                                            className="nav-link-inner--text">{language[lang].MyLessons}</span>
                                                    </Button>
                                                </Tooltip>
                                                <Tooltip title='Exams'>
                                                    <Button
                                                        onClick={() => this.routeHandler(constants.HOME_EXAM_ROUTE)}
                                                        className={`btn-neutral ${active === 4 ? `nav-link-active` : ``}`}
                                                        color="default">
                                                        <span
                                                            className="nav-link-inner--text">{language[lang].Exams}</span>
                                                    </Button>
                                                </Tooltip>
                                                <Tooltip title='Profile'>
                                                    <Button
                                                        onClick={() => this.routeHandler(constants.HOME_PROFILE_ROUTE)}
                                                        className={`btn-neutral ${active === 3 ? `nav-link-active` : ``}`}
                                                        color="default">
                                                        <span
                                                            className="nav-link-inner--text">{language[lang].Profile}</span>
                                                    </Button>
                                                </Tooltip>

                                            </NavItem>

                                            : null
                                    }

                                    {/*mobile - end*/}

                                    {
                                        userType === 1 &&
                                        <NavItem className={"d-none d-lg-block"}>
                                            <Tooltip title='Home Page'>
                                                <NavLink
                                                    className={`${"nav-link-item nav-text"} ${active === 0 ? `nav-link-active` : ``}`}
                                                    onClick={() => this.routeHandler(constants.HOME_INSTITUTE_ROUTE)}>
                                                    {language[lang].HomePage}
                                                </NavLink>
                                            </Tooltip>
                                        </NavItem>
                                    }
                                    {
                                        userType === 1 &&
                                        <NavItem className={"d-none d-lg-block"}>
                                            <Tooltip title='Enrolled Classes'>
                                                <NavLink
                                                    className={`${"nav-link-item nav-text"} ${active === 1 ? `nav-link-active` : ``}`}
                                                    onClick={() => this.routeHandler(constants.HOME_MY_CLASS_ROUTE)}>
                                                    {language[lang].MyClass}
                                                </NavLink>
                                            </Tooltip>
                                        </NavItem>
                                    }
                                    {
                                        userType === 1 &&
                                        <NavItem className={"d-none d-lg-block"}>
                                            <Tooltip title='Enrolled Lessons'>
                                                <NavLink
                                                    className={`${"nav-link-item nav-text"} ${active === 2 ? `nav-link-active` : ``}`}
                                                    onClick={() => this.routeHandler(constants.HOME_MY_LESSONS_ROUTE)}>
                                                    {language[lang].MyLessons}
                                                </NavLink>
                                            </Tooltip>
                                        </NavItem>
                                    }
                                    {
                                        userType === 1 &&
                                        <NavItem className="d-none d-lg-block">
                                            <Tooltip title='Exams'>
                                                <NavLink
                                                    className={`${"nav-link-item nav-text"} ${active === 4 ? `nav-link-active` : ``}`}
                                                    onClick={() => this.routeHandler(constants.HOME_EXAM_ROUTE)}>
                                                    {language[lang].Exams}
                                                </NavLink>
                                            </Tooltip>
                                        </NavItem>
                                    }
                                </Nav>


                                <Nav className="align-items-lg-center ml-lg-auto" navbar>
                                    {/*mobile*/}
                                    {
                                        userType === 1 ?
                                            <NavItem className="d-lg-none ml-lg-4">
                                                <Tooltip title='Log out'>
                                                    <Button className=" com-btn reg-btn" color="default"
                                                            onClick={this.logoutHandler}>
                                                        <span className="-btn"/>
                                                        <span
                                                            className="nav-link-inner--text ml-1 ">{language[lang].Logout}</span>
                                                    </Button>
                                                </Tooltip>
                                            </NavItem> :
                                            <NavItem className="d-lg-none ml-lg-4">
                                                <Button className=" com-btn log-btn  mb-1" color="default"
                                                        onClick={() => this.setModalHandler("LOGIN")}>

                                                    <span
                                                        className="nav-link-inner--text ml-1">{language[lang].LoginPage}</span>
                                                </Button>

                                                <Button className=" com-btn reg-btn" color="warning"
                                                        onClick={() => this.setModalHandler("REG")}>

                                                    <span
                                                        className="nav-link-inner--text ml-1">{language[lang].Register}</span>
                                                </Button>

                                            </NavItem>
                                    }
                                    {/*mobile - end*/}

                                    {
                                        userType === 1 &&
                                        // <NavItem className="d-none d-lg-block ml-lg-4">
                                        //     <Tooltip title='Log out'>
                                        //         <Button className="com-btn reg-btn" color="default"
                                        //                 onClick={this.logoutHandler}>
                                        //             <span className="btn-inner--icon"/>
                                        //             <span
                                        //                 className="nav-link-inner--text ml-1">{language[lang].Logout}</span>
                                        //         </Button>
                                        //     </Tooltip>
                                        // </NavItem>
                                        <div className="d-none d-lg-flex ml-lg-4"
                                             style={{alignItems: "center"}}>
                                            <div>
                                                <div className="font-weight-bold user_name">
                                                    {this.props.userObj.name}</div>
                                            </div>
                                            <AppHeaderDropdown direction="down" >
                                                <DropdownToggle nav className="pt-0 pb-0">
                                                    <div style={{width: '45px', height: '45px', borderRadius: '50px', alignContent: "center"}}>
                                                        <img src={cornerImage} style={{height: '45px'}} alt="user" />
                                                    </div>
                                                </DropdownToggle>
                                                <DropdownMenu right>
                                                    <DropdownItem onClick={() => this.routeHandler(constants.HOME_PROFILE_ROUTE)}>
                                                        <i className="fa fa-cog"/>{language[lang].Profile}</DropdownItem>
                                                    <DropdownItem onClick={this.logoutHandler}><i className="fa fa-lock"/>{language[lang].Logout}</DropdownItem>
                                                </DropdownMenu>
                                            </AppHeaderDropdown>
                                        </div>
                                    }
                                    {
                                        userType === 0 &&
                                        <NavItem className="d-none d-lg-block ml-lg-4">
                                            <Button className="com-btn log-btn"
                                                    onClick={() => this.setModalHandler("LOGIN")}>
                                                <span className="btn-inner--icon"/>
                                                <span
                                                    className="nav-link-inner--text ml-1"> {language[lang].LoginPage} </span>
                                            </Button>
                                        </NavItem>

                                    }
                                    {
                                        userType === 0 &&
                                        <NavItem className="d-none d-lg-block ml-lg-4">
                                            <Button className="com-btn reg-btn"
                                                    onClick={() => this.setModalHandler("REG")}>
                                                <span
                                                    className="nav-link-inner--text ml-1 reg-text"> {language[lang].StudentRegistration} </span>
                                                <span className="btn-inner--icon reg-flash"/>
                                            </Button>
                                        </NavItem>
                                    }


                                </Nav>
                            </UncontrolledCollapse>
                        </Container>
                    </Navbar>
                </header>

            </>
        );
    }
}

const mapStateToProps = (state) => ({
    userType: state.auth.userType,
    userObj: state.student.userObj
});
const mapDispatchToProps = (dispatch) => ({
    setUserType: data => dispatch(actionCreator.setUserType(data)),
    selectPagination: data => dispatch(actionClassCreator.selectPagination(data)),
    selectMyClassPagination: data => dispatch(actionClassCreator.selectMyClassPagination(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(DemoNavbar));
